import ErrorPage from './default';
import { CHECKOUT_ERROR_PAGE_TEXT } from './constants';

function CheckoutErrorPage(props) {
  return (
    <ErrorPage
      {...props}
      title={CHECKOUT_ERROR_PAGE_TEXT.TITLE}
      description={CHECKOUT_ERROR_PAGE_TEXT.DESCRIPTION}
      showLink={false}
    />
  );
}
export default CheckoutErrorPage;
